import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Banner.css';
import slide1 from './../../images/image-mg-2.jpg';
import slide2 from './../../images/image-mg-1.jpg';
import slide3 from './../../images/image-mg-3.jpg';
import { Link } from 'react-router-dom';
import useNavigation from '../../utils/Navigation';

const Banner = () => {
  const navigateToSection = useNavigation();
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    arrows: false,
  };

  return (
    <section className="hero-banner">
      <div className="hero-container">
        <div className="hero-text">
          <h6>Could an Investigational Therapy Help Improve Your Daily Life?</h6>
          <h1>Participate in a Research Study for Generalized Myasthenia Gravis</h1>
          <p>The AURORA trial is evaluating a new investigational study drug (Descartes-08) for people with acetylcholine receptor antibody-positive generalized myasthenia gravis.</p>
          <ul className="benefits">
            <li>Study-related care provided</li>
            <li>No insurance is required to participate</li>
            <li>You will be closely monitored by experienced healthcare professionals</li>
          </ul>
          <Link to="/#eligibility" onClick={() => navigateToSection('eligibility')}>
            <button className="cta-button">See if you qualify</button>
          </Link>
        </div>

        <div className="hero-slider">
          <Slider {...settings}>
            <div><img src={slide1} alt="Slide 1" /></div>
            <div><img src={slide2} alt="Slide 2" /></div>
            <div><img src={slide3} alt="Slide 3" /></div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Banner;
